export const styles = theme => ({
  wrapper: {
    background: theme.palette.primary.dark,
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1250,
    '&> canvas': {
      position: 'fixed',
      willChange: 'transform',
      transform: 'scale(1.1)',
      transformOrigin: 'center',
      pointerEvents: 'none'
    }
  }
})

export const particleStyles = {
  particles: {
    number: { value: 80, density: { enable: true, value_area: 800 } },
    color: { value: '#fff' },
    shape: {
      type: 'circle',
      stroke: { width: 0, color: '#000' },
      polygon: { nb_sides: 5 },
      image: { src: '', width: 100, height: 100 }
    },
    opacity: {
      value: 0.4,
      random: false,
      anim: { enable: false, speed: 1, opacity_min: 0, sync: false }
    },
    size: {
      value: 4,
      random: true,
      anim: { enable: false, speed: 40, size_min: 0.1, sync: false }
    },
    line_linked: {
      enable: true,
      distance: 150,
      color: '#ffffff',
      opacity: 0.3,
      width: 1
    },
    move: {
      enable: true,
      speed: 4,
      direction: 'right',
      random: false,
      straight: false,
      out_mode: 'out',
      bounce: false,
      attract: { enable: false, rotateX: 600, rotateY: 1200 }
    }
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: { enable: false, mode: 'repulse' },
      onclick: { enable: false, mode: 'push' },
      resize: true
    },
    modes: {
      grab: { distance: 400, line_linked: { opacity: 1 } },
      bubble: { distance: 400, size: 40, duration: 2, opacity: 8, speed: 3 },
      repulse: { distance: 200, duration: 0.4 },
      push: { particles_nb: 4 },
      remove: { particles_nb: 2 }
    }
  },
  retina_detect: true
}

export default styles



// WEBPACK FOOTER //
// ./src/styles/components/ParticleBackground.js